<script setup lang="ts">
import { nextTick, onBeforeUnmount, ref } from 'vue'

const props = defineProps({
  zIndex: { type: Number, default: 9999 },
})

const _show = ref<any>(false)
const refCustomeContextMenu = ref<any>()
const show = (x, y) => {
  _show.value = true
  nextTick(()=>{
    refreshPostion(x, y)
    // 点击其他地方隐藏菜单
    document.addEventListener('mousedown', handleClickOutside);
  })
}
const move = (x,y) => {
  if (x) refCustomeContextMenu.value.style.left = `${x}px`
  if (y) refCustomeContextMenu.value.style.top = `${y}px`
}

const refreshPostion = (x:any=null, y:any=null) => {
  if (!x || !y) {
    x = Number(refCustomeContextMenu.value.style.left.split('px')[0])
    y = Number(refCustomeContextMenu.value.style.top.split('px')[0])
  }
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const menuWidth = refCustomeContextMenu.value.offsetWidth;
  const menuHeight = refCustomeContextMenu.value.offsetHeight;
  // 菜单的初始位置
  let left = x;
  let top = y;
  // 检查是否会超出窗口右侧边界
  if (left + menuWidth > windowWidth) {
    left = windowWidth - menuWidth;
  }
  // 检查是否会超出窗口底部边界
  if (top + menuHeight > windowHeight) {
    top = windowHeight - menuHeight;
  }
  console.log('refreshPostion:',x,y,menuHeight,windowHeight)
  refCustomeContextMenu.value.style.left = `${left}px`
  refCustomeContextMenu.value.style.top = `${top}px`
}

const handleClickOutside = (e) => {
  const customMenu = document.querySelector('.custom-context-menu');
  if (customMenu && !customMenu.contains(e.target)) {
    _show.value = false;
    document.removeEventListener('mousedown', handleClickOutside);
  }
}

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside);
})

const hide = () => {
  _show.value = false;
  document.removeEventListener('mousedown', handleClickOutside);
}

defineExpose({
  show,
  hide,
  move,
  refreshPostion,
})
</script>

<template>
  <div
    v-if="_show"
    ref="refCustomeContextMenu"
    class="custom-context-menu"
    :style="{zIndex:props.zIndex}">
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
.custom-context-menu {
  position: fixed;
}
</style>